import { render, staticRenderFns } from "./AddManagementPolicy.vue?vue&type=template&id=0fe8098c&scoped=true"
import script from "./AddManagementPolicy.vue?vue&type=script&lang=js"
export * from "./AddManagementPolicy.vue?vue&type=script&lang=js"
import style0 from "./AddManagementPolicy.vue?vue&type=style&index=0&id=0fe8098c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe8098c",
  null
  
)

export default component.exports